<template>
  <div class="row mt-4 ms-1 me-1">
    <section-header>Co możesz zrobić podejrzewając tę usterkę?</section-header>
    <p v-html="diy" class="diy list-p-margin"></p>
  </div>
</template>
<script>
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
export default {
  components: { SectionHeader },
  props: {
    diy: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.diy {
  padding: 8px 8px 8px 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  background: rgba(0, 114, 219, 0.1);
}
</style>
